import { render, staticRenderFns } from "./ExhibitCreationPage.vue?vue&type=template&id=c2d5fe72&scoped=true&"
import script from "./ExhibitCreationPage.vue?vue&type=script&lang=js&"
export * from "./ExhibitCreationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d5fe72",
  null
  
)

export default component.exports